const APP_FLAGS = {
    ATHLETE_WEB_TRANSACTIONS: "athlete-web-transactions",
};
const SCHOOL_FLAGS = {
    COMPLIANCE_V3_BETA: 'Compliance v3 Beta',
    WALLET_ENABLED: 'Wallet Beta',
};
const TEAM_FLAGS = {};
const USER_FLAGS = {};
const BRAND_FLAGS = {
    AGREEMENTS_V2_UX: 'Agreements v2 UX',
    SIGNATURES: 'Signatures',
};
export { APP_FLAGS, SCHOOL_FLAGS, TEAM_FLAGS, USER_FLAGS, BRAND_FLAGS, };
